import React, { type FC } from 'react'
import { Grid, Paper, type SxProps, type Theme, Typography } from '@mui/material'

import { BufferType, type TailedTopicMessage } from '../../../../domain'

import { FormattedBuffer, ReversedTruncatedText, useBufferTypeTranslator } from '../../common'
import { FormattedDateTime } from '../../Internationalization'

const wrapperStyle: SxProps<Theme> = {
    mb: 2,
    py: 1,
    px: 0,
    '& > * > :first-of-type': { pl: 2 },
    '& > * > :last-of-type': { pr: 2 },
}
const longTextStyle: SxProps<Theme> = { overflowX: 'hidden', pr: 2, display: 'flex', alignItems: 'center' }
const verticalAlignedStyle: SxProps<Theme> = { display: 'flex', alignItems: 'center' }

export const TailLine: FC<TailedTopicMessage> = ({ topic, timestamp, payload, selectedType }) => {
    const translate = useBufferTypeTranslator()

    return (
        <Paper sx={wrapperStyle} variant="outlined">
            <Grid container sx={verticalAlignedStyle}>
                <Grid size={{ xs: 2 }}>
                    <Typography variant="caption">
                        <FormattedDateTime date={timestamp} format="datetime" />
                    </Typography>
                </Grid>
                <Grid size={{ xs: 5 }}>
                    <Typography sx={longTextStyle} title={topic} variant="body1">
                        <ReversedTruncatedText>{topic}</ReversedTruncatedText>
                    </Typography>
                </Grid>
                <Grid size={{ xs: 4 }}>
                    <FormattedBuffer sx={[selectedType === BufferType.OBJECT ? {} : longTextStyle]} buffer={payload} type={selectedType} />
                </Grid>
                <Grid size={{ xs: 1 }}>{translate(selectedType)}</Grid>
            </Grid>
        </Paper>
    )
}
